/* tslint:disable */
/* eslint-disable */
/**
 * Simulations API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @interface RunSimulationRequest
 */
export interface RunSimulationRequest {
    /**
     * 
     * @type {string}
     * @memberof RunSimulationRequest
     */
    'flow_slug': string;
    /**
     * 
     * @type {string}
     * @memberof RunSimulationRequest
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof RunSimulationRequest
     */
    'dataset_id': string;
    /**
     * 
     * @type {string}
     * @memberof RunSimulationRequest
     */
    'flow_version_id': string;
    /**
     * 
     * @type {string}
     * @memberof RunSimulationRequest
     */
    'flow_version_etag': string;
}
/**
 * 
 * @export
 * @interface RunSimulationResponse
 */
export interface RunSimulationResponse {
    /**
     * 
     * @type {string}
     * @memberof RunSimulationResponse
     */
    'job_id': string;
    /**
     * 
     * @type {string}
     * @memberof RunSimulationResponse
     */
    'job_run_id': string;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}

/**
 * SimulationsApi - axios parameter creator
 * @export
 */
export const SimulationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Marks a simulation as deleted
         * @param {string} simulationJobRunId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markSimulationAsDeletedSimulationsApiV1SimulationsSimulationJobRunIdDelete: async (simulationJobRunId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationJobRunId' is not null or undefined
            assertParamExists('markSimulationAsDeletedSimulationsApiV1SimulationsSimulationJobRunIdDelete', 'simulationJobRunId', simulationJobRunId)
            const localVarPath = `/simulations/api/v1/simulations/{simulation_job_run_id}`
                .replace(`{${"simulation_job_run_id"}}`, encodeURIComponent(String(simulationJobRunId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a simulation
         * @param {RunSimulationRequest} runSimulationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runSimulationSimulationsApiV1SimulationsPost: async (runSimulationRequest: RunSimulationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runSimulationRequest' is not null or undefined
            assertParamExists('runSimulationSimulationsApiV1SimulationsPost', 'runSimulationRequest', runSimulationRequest)
            const localVarPath = `/simulations/api/v1/simulations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runSimulationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SimulationsApi - functional programming interface
 * @export
 */
export const SimulationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SimulationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Marks a simulation as deleted
         * @param {string} simulationJobRunId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markSimulationAsDeletedSimulationsApiV1SimulationsSimulationJobRunIdDelete(simulationJobRunId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markSimulationAsDeletedSimulationsApiV1SimulationsSimulationJobRunIdDelete(simulationJobRunId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulationsApi.markSimulationAsDeletedSimulationsApiV1SimulationsSimulationJobRunIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start a simulation
         * @param {RunSimulationRequest} runSimulationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runSimulationSimulationsApiV1SimulationsPost(runSimulationRequest: RunSimulationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RunSimulationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runSimulationSimulationsApiV1SimulationsPost(runSimulationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulationsApi.runSimulationSimulationsApiV1SimulationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SimulationsApi - factory interface
 * @export
 */
export const SimulationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SimulationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Marks a simulation as deleted
         * @param {SimulationsApiMarkSimulationAsDeletedSimulationsApiV1SimulationsSimulationJobRunIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markSimulationAsDeletedSimulationsApiV1SimulationsSimulationJobRunIdDelete(requestParameters: SimulationsApiMarkSimulationAsDeletedSimulationsApiV1SimulationsSimulationJobRunIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markSimulationAsDeletedSimulationsApiV1SimulationsSimulationJobRunIdDelete(requestParameters.simulationJobRunId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a simulation
         * @param {SimulationsApiRunSimulationSimulationsApiV1SimulationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runSimulationSimulationsApiV1SimulationsPost(requestParameters: SimulationsApiRunSimulationSimulationsApiV1SimulationsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<RunSimulationResponse> {
            return localVarFp.runSimulationSimulationsApiV1SimulationsPost(requestParameters.runSimulationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for markSimulationAsDeletedSimulationsApiV1SimulationsSimulationJobRunIdDelete operation in SimulationsApi.
 * @export
 * @interface SimulationsApiMarkSimulationAsDeletedSimulationsApiV1SimulationsSimulationJobRunIdDeleteRequest
 */
export interface SimulationsApiMarkSimulationAsDeletedSimulationsApiV1SimulationsSimulationJobRunIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof SimulationsApiMarkSimulationAsDeletedSimulationsApiV1SimulationsSimulationJobRunIdDelete
     */
    readonly simulationJobRunId: string
}

/**
 * Request parameters for runSimulationSimulationsApiV1SimulationsPost operation in SimulationsApi.
 * @export
 * @interface SimulationsApiRunSimulationSimulationsApiV1SimulationsPostRequest
 */
export interface SimulationsApiRunSimulationSimulationsApiV1SimulationsPostRequest {
    /**
     * 
     * @type {RunSimulationRequest}
     * @memberof SimulationsApiRunSimulationSimulationsApiV1SimulationsPost
     */
    readonly runSimulationRequest: RunSimulationRequest
}

/**
 * SimulationsApi - object-oriented interface
 * @export
 * @class SimulationsApi
 * @extends {BaseAPI}
 */
export class SimulationsApi extends BaseAPI {
    /**
     * 
     * @summary Marks a simulation as deleted
     * @param {SimulationsApiMarkSimulationAsDeletedSimulationsApiV1SimulationsSimulationJobRunIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimulationsApi
     */
    public markSimulationAsDeletedSimulationsApiV1SimulationsSimulationJobRunIdDelete(requestParameters: SimulationsApiMarkSimulationAsDeletedSimulationsApiV1SimulationsSimulationJobRunIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return SimulationsApiFp(this.configuration).markSimulationAsDeletedSimulationsApiV1SimulationsSimulationJobRunIdDelete(requestParameters.simulationJobRunId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a simulation
     * @param {SimulationsApiRunSimulationSimulationsApiV1SimulationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimulationsApi
     */
    public runSimulationSimulationsApiV1SimulationsPost(requestParameters: SimulationsApiRunSimulationSimulationsApiV1SimulationsPostRequest, options?: RawAxiosRequestConfig) {
        return SimulationsApiFp(this.configuration).runSimulationSimulationsApiV1SimulationsPost(requestParameters.runSimulationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



